import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { Url } from '@wix/da-url';
import { ResourceType } from '../types/resource';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
export const CommentLink = (_param)=>{
    var { comment, children } = _param, restProps = _object_without_properties(_param, [
        "comment",
        "children"
    ]);
    var _comment_user;
    return /*#__PURE__*/ React.createElement(BiLink, _object_spread({
        href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId),
        biData: BiData({
            evid: 100,
            typeid: ResourceType.COMMENT,
            itemid: comment.commentId,
            creatorid: (_comment_user = comment.user) === null || _comment_user === void 0 ? void 0 : _comment_user.useridUuid,
            page_typeid: BiContextProvidedValue,
            page_itemid: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        })
    }, restProps), children);
};
CommentLink.displayName = 'CommentLink';
export default CommentLink;

//# sourceMappingURL=CommentLink.js.map